import { negotiations } from './role'

export const queries = {
  negotiations,
}
export default queries
